<script>
export default {
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  computed: {
    isLinkAction() {
      return this.action?.type === 'link' && this.action?.to;
    },
    linkBind() {
      if (this.isLinkAction) return { to: this.action.to };
      return {};
    },
    titleCardClasses() {
      return 'mb-2 inline-flex max-w-[28rem] min-w-[15rem] flex-col gap-2 rounded-xl border border-n-strong bg-n-solid-1/95 px-4 py-3 text-left shadow-lg backdrop-blur-sm dark:bg-n-solid-2/95 sm:min-w-[18rem]';
    },
    titleCardInteractiveClasses() {
      if (!this.isLinkAction) return '';
      return 'cursor-pointer no-underline text-inherit outline-none ring-n-brand transition-shadow hover:shadow-md focus-visible:ring-2';
    },
    compactCardClasses() {
      return 'mb-2 inline-flex min-h-[1.875rem] max-w-[25rem] min-w-[15rem] items-center gap-3 rounded-lg bg-n-slate-12 px-6 py-3 text-left shadow-sm dark:bg-n-slate-7';
    },
    compactInteractiveClasses() {
      if (!this.isLinkAction) return '';
      return 'cursor-pointer no-underline text-inherit outline-none ring-n-brand transition-opacity hover:opacity-95 focus-visible:ring-2';
    },
    linkLabel() {
      const a = this.action;
      if (!a || a.type !== 'link') return '';
      if (a.linkLabel) return a.linkLabel;
      if (a.usei18nLink && a.linkLabelKey) {
        // Fallback if label was not pre-resolved (e.g. legacy emitters).
        // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
        return this.$t(a.linkLabelKey);
      }
      return a.message || '';
    },
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <component
      :is="isLinkAction ? 'router-link' : 'div'"
      v-if="title"
      v-bind="linkBind"
      :class="[titleCardClasses, titleCardInteractiveClasses]"
    >
      <div class="min-w-0">
        <div
          class="line-clamp-2 text-sm font-semibold text-n-slate-12 dark:text-n-slate-12"
        >
          {{ title }}
        </div>
        <div
          class="mt-1 line-clamp-3 text-sm text-n-slate-11 dark:text-n-slate-11"
        >
          {{ message }}
        </div>
      </div>
      <div v-if="isLinkAction && linkLabel" class="flex shrink-0 justify-end">
        <span class="text-sm font-medium text-n-brand">
          {{ linkLabel }}
        </span>
      </div>
    </component>
    <component
      :is="isLinkAction ? 'router-link' : 'div'"
      v-else
      v-bind="linkBind"
      :class="[compactCardClasses, compactInteractiveClasses]"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
      </div>
      <span
        v-if="isLinkAction && (linkLabel || action.message)"
        class="cursor-pointer select-none font-medium text-n-blue-10"
      >
        {{ linkLabel || action.message }}
      </span>
    </component>
  </div>
</template>
